"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OperatorAttendanceColumnFullScreenProps = exports.OperatorAttendanceColumnProps = void 0;
const constants_1 = require("utils/constants");
const OperatorAttendanceColumnProps = [
    {
        show: true,
        field: 'fullname',
        title: 'Name',
        width: '250',
        filter: 'text',
    },
    {
        show: true,
        field: 'username',
        title: 'Username',
        width: '200',
        filter: 'text'
    },
    {
        show: true,
        field: 'location',
        title: 'Location',
        width: '200',
        filter: 'text',
    },
    {
        show: true,
        field: 'login_time',
        title: 'Login Time',
        width: '200',
        format: `${constants_1.formatGridDate.ddMMYYYY} ${constants_1.formatGridDate.hhMMss}`,
        filterable: false
    },
    {
        show: true,
        field: 'logout_time',
        title: 'Logout Time',
        width: '200',
        format: `${constants_1.formatGridDate.ddMMYYYY} ${constants_1.formatGridDate.hhMMss}`,
        filterable: false
    },
    {
        show: true,
        field: 'duration',
        title: 'Duration',
        width: '300',
        filterable: false,
        format: `${constants_1.formatGridDate.hhMMss}`
    }
];
exports.OperatorAttendanceColumnProps = OperatorAttendanceColumnProps;
const OperatorAttendanceColumnFullScreenProps = [
    {
        show: true,
        field: 'fullname',
        title: 'Name',
        width: '300',
        filter: 'text',
    },
    {
        show: true,
        field: 'username',
        title: 'Username',
        width: '300',
        filter: 'text'
    },
    {
        show: true,
        field: 'location',
        title: 'Location',
        width: 'auto',
        filter: 'text',
    },
    {
        show: true,
        field: 'login_time',
        title: 'Login Time',
        width: 'auto',
        format: `${constants_1.formatGridDate.ddMMYYYY} ${constants_1.formatGridDate.hhMMss}`,
        filterable: false
    },
    {
        show: true,
        field: 'logout_time',
        title: 'Logout Time',
        width: 'auto',
        format: `${constants_1.formatGridDate.ddMMYYYY} ${constants_1.formatGridDate.hhMMss}`,
        filterable: false
    },
    {
        show: true,
        field: 'duration',
        title: 'Duration',
        width: 'auto',
        filterable: false,
        format: `${constants_1.formatGridDate.hhMMss}`
    }
];
exports.OperatorAttendanceColumnFullScreenProps = OperatorAttendanceColumnFullScreenProps;
